import {AvalancheReelController} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelController";
import {IReelStartSpinData, ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Ease, Linear, TimelineLite, TweenLite} from "gsap";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IAvalancheParsedServerData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {MGReelEvents, MGReelPartAnimator} from "./MGReelPartAnimator";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MonkeysGoldParsedGameData} from "../server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldReelSymbol} from "../symbols/MonkeysGoldReelSymbol";
import {IExistingBigSymbols} from "../server/data/IExistingBigSymbols";
import {MonkeysGoldParsedInitData} from "../server/data/MonkeysGoldParsedInitData";
import {MonkeysGoldGameModuleConfig} from "../MonkeysGoldGameModuleConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class MGReelController extends AvalancheReelController {

    private _bigSymbolMultiplier:number;
    private _bigSymbolFinalMultiplier:number;
    private _bigSymbolSize:number;
    private _isRestore:boolean;
    private _existingBigSymbols:IExistingBigSymbols[];
    private _winSymbolsPlayed:boolean[] = [false, false, false, false, false, false];
    private _spinStopEase:CustomEase;

    protected parseInitData(data:MonkeysGoldParsedInitData & IAvalancheParsedServerData):void {
        super.parseInitData(data);
        this._existingBigSymbols = data.existingBigSymbols;
        this._isRestore = data.isRestoreState;
        this._reelsAfterCollapes = data.reelsAfterCollapse[this._reelId];
        this._allWinPositions = ArrayHelper.initArrayWithValues(this._symNumTotal, (index:number) => this._reelsAfterCollapes[index] !== ReelSymbolName.EMPTY);
    }

    public onGameDataParsed(data:MonkeysGoldParsedGameData):void {
        this._isRestore = false;
        super.onGameDataParsed(data);
        if(this._gameMode == GameMode.NORMAL && this._nextGameMode == GameMode.NORMAL_AVALANCHE) {

        }
        this._bigSymbolMultiplier = data.bigSymbolMultiplier;
        this._bigSymbolFinalMultiplier = data.bigSymbolFinalMultiplier;
        this._bigSymbolSize = data.bigSymbolSize;
        this._spinStopEase = CustomEase.create("spinStopEase", "M0,0,C0.058,0.259,0.104,0.494,0.212,0.654,0.33,0.83,0.172,0.959,0.312,1,0.352,1.01,0.377,1.008,0.456,0.99,0.515,0.975,0.624,0.982,0.668,0.982,0.706,0.982,0.67,0.998,0.684,1,0.706,1.002,0.943,1,1,1");
    }

    private getAllNewWinPositions():boolean[] {
        const newWins:boolean[] = [];
        for(let i:number = 0; i < this._allWinPositions.length; i++) {
            if(this._allWinPositions[i] == true && this._winSymbolsPlayed[i] == false) {
                newWins.push(true);
            } else {
                newWins.push(false);
            }
        }

        for(let i:number = 0; i < this._reelsAfterCollapes.length; i++) {
            if(this._reelsAfterCollapes[i] == "X") {
                this._winSymbolsPlayed[i] = false;
            } else {
                this._winSymbolsPlayed[i] = true;
            }
        }
        return newWins;
    }

    private calculateLandingSmokePosition():PIXI.Point[] {
        const landingSmokePositions:PIXI.Point[] = [];
        for(let i:number = 0; i < this._allWinPositions.length; i++) {
            if(this._allWinPositions[i] == true) {
                //How many false bellow = how many steps will in fall down?
                let fallDownCounter:number = 0;
                for(let j:number = i; j < this._allWinPositions.length; j++) {
                    if(this._allWinPositions[j] == false) {
                        fallDownCounter++;
                    }
                }
                if(fallDownCounter > 0) {
                    landingSmokePositions.push(new PIXI.Point(this._reelId, (i + fallDownCounter)));
                }
            }
        }
        return landingSmokePositions;
    }

    protected startSpinAnimation(data:IReelStartSpinData, previousDelay:number):number {
        this._isSpinBlurred = true;
        let delay = previousDelay;
        const timeline:TimelineLite = new TimelineLite();
        if(this.isAvalanche()) {
            this._currentState = ReelAnimationState.AVALANCHE_START;
            if(this._allWinPositions.includes(false)) {
                const positions:boolean[] = this._allWinPositions.concat();
                timeline.add(MonkeysGoldGameModuleConfig.monkeysGoldAvalancheSymbolAttentionController.getAvalancheSymbolAttentionTL(this._reelId, this.getAllNewWinPositions(), this._allWinPositions));
                (<MGReelPartAnimator>this._avalancheReelPartAnimator).playIndividualSymbolSound = true;
                timeline.add(this._avalancheReelPartAnimator.getAvalancheAnimation(positions, null, 0,
                    (symbol:StateReelSymbol) => this.doNothing(symbol)), "-=0.2");
                timeline.add(MonkeysGoldGameModuleConfig.monkeysGoldAvalancheSymbolAttentionController.getLandingAnimationTL(this.calculateLandingSmokePosition(), this._reelId));
                if(this._reelId == 5) {
                    timeline.add(MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.getRowLockAnimationTL());
                    timeline.add(() => {}, "+=0.5");
                }
            } else {
                timeline.add(MonkeysGoldGameModuleConfig.monkeysGoldAvalancheSymbolAttentionController.getAvalancheSymbolAttentionTL(this._reelId, this.getAllNewWinPositions(), this._allWinPositions));
                if(this._reelId == 5) {
                    timeline.add(MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.getRowLockAnimationTL(), "+=0.3");
                }
                EventHandler.dispatchEvent(new GameEvent(MGReelEvents.SYMBOL_DROP_COMPLETED, this.reelId));
            }
        } else {
            this._currentState = ReelAnimationState.ALL_OUT;
            EventHandler.dispatchEvent(new GameEvent(MGReelEvents.SYMBOLS_ALL_OUT, this.reelId));
            this._winSymbolsPlayed = [false, false, false, false, false, false];
            delay = previousDelay + (this.reelId === 0 ? 0 : (data.fastSpin ? ReelController._reelFastStartDelays[this._reelId] : ReelController._reelStartDelays[this._reelId]));
            timeline.add(() => this._avalancheReelPartAnimator.getAllOutAnimation(delay, (symbol:StateReelSymbol) => this.removeSymbol(symbol)));
        }

        timeline.add(() => this.onSpinStartedCompleted());
        return delay;
    }

    private doNothing(symbolToRemove:StateReelSymbol):void {

    }

    protected removeSymbol(symbolToRemove:StateReelSymbol):void {
        const removeSymbolTL:TimelineLite = new TimelineLite();
        removeSymbolTL.add(new TweenLite(symbolToRemove, 0.3, {alpha : 0, ease : Linear.easeNone}));
        removeSymbolTL.add(() => this._reelView.removeChild(symbolToRemove));
        removeSymbolTL.add(() => this._reelPartCreator.deleteSymbol(symbolToRemove));
    }

    protected addNewSymbol(symName:string, state?:ISymbolStateConfig):StateReelSymbol {
        if(state == null) {
            state = this._isSpinBlurred ? GameConfig.instance.SYMBOL_STATES.spin : GameConfig.instance.SYMBOL_STATES.normal;
        }

        const symbol:StateReelSymbol = this._reelPartCreator.createNewSymbol(symName, this._reelId, state, {
            width : this._reelPartAnimator.symWidth,
            height : this._reelPartAnimator.symHeight,
            bottomPadding : this._reelPartAnimator.symBottomPadding
        });
        symbol.x = 0;
        symbol.y = -symbol.symHeight / 2 - GameConfig.instance.REEL_AREA_POS_Y - GameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][1]; // this is just a temp position that's not visible. this position might be visible in portrait mode but it doesn't matter. the position will be updated when put the symbol to the animator.
        this._reelView.addChild(symbol);
        if(symbol.symName.indexOf("hidden") > -1) {
            symbol.visible = false;
        }

        if(symbol.symName.indexOf("colossalx2") > -1 || symbol.symName.indexOf("colossalx3") > -1) {
            const currentRow:number = 6 - this._reelView.children.length;
            if(this._isRestore == true) {
                //Find symbol in existing symbols and set correct multiplier value
                for(let i:number = 0; i < this._existingBigSymbols.length; i++) {
                    if(currentRow == this._existingBigSymbols[i].bottomLeftPosition[1] && this._reelId == (this._existingBigSymbols[i].bottomLeftPosition[0] + (this._existingBigSymbols[i].symbolSize - 1))) {
                        if(this._existingBigSymbols[i].symbolFinalMultiplier > this._existingBigSymbols[i].symbolMultiplier) {
                            (<MonkeysGoldReelSymbol>symbol).bigSymbolMultiplier = this._existingBigSymbols[i].symbolFinalMultiplier;
                            (<MonkeysGoldReelSymbol>symbol).bigSymbolFinalMultiplier = this._existingBigSymbols[i].symbolFinalMultiplier;
                        } else {
                            (<MonkeysGoldReelSymbol>symbol).bigSymbolMultiplier = this._existingBigSymbols[i].symbolMultiplier;
                            (<MonkeysGoldReelSymbol>symbol).bigSymbolFinalMultiplier = this._existingBigSymbols[i].symbolFinalMultiplier;
                        }
                        (<MonkeysGoldReelSymbol>symbol).initMultiplierText(this._existingBigSymbols[i].symbolSize);
                        (<MonkeysGoldReelSymbol>symbol).initUpgradeAnimation(this._existingBigSymbols[i].symbolSize);
                        (<MonkeysGoldReelSymbol>symbol).bottomLeftPosition = [this.reelId, currentRow];
                    }
                }
            } else {
                (<MonkeysGoldReelSymbol>symbol).bigSymbolMultiplier = this._bigSymbolMultiplier;
                (<MonkeysGoldReelSymbol>symbol).bigSymbolFinalMultiplier = this._bigSymbolFinalMultiplier;
                (<MonkeysGoldReelSymbol>symbol).bottomLeftPosition = [this.reelId, currentRow];
            }
        }

        return symbol;
    }

    public replaceWithNewSymbol(oldSymbol:StateReelSymbol, symName:string, deleteOld:boolean, state?:ISymbolStateConfig):any {
        const newSymbol = this.addNewSymbol(symName, state);
        newSymbol.x = oldSymbol.x;
        newSymbol.y = oldSymbol.y;

        const reelPartIndex = this._reelPartAnimator.symbolsToAnimate.indexOf(oldSymbol);
        this._reelPartAnimator.symbolsToAnimate[reelPartIndex] = newSymbol;

        const stopSymbolIndex = this.allSymbols.indexOf(oldSymbol);
        this.allSymbols[stopSymbolIndex] = newSymbol;

        if(deleteOld) {
            this.removeTheOldSymbol(oldSymbol);
        }
        return newSymbol;
    }

    public removeTheOldSymbol(oldSymbol:StateReelSymbol) {
        this._reelPartCreator.deleteSymbol(oldSymbol);
    }

}